import axiosCustom from "../utils/axiosInstance";
import keycloak from "../auth/keycloak";

const logout = async (): Promise<void> => {
  const refreshToken = keycloak.refreshToken;

  if (!refreshToken) {
    return;
  }

  const params = new URLSearchParams();
  params.append("client_id", keycloak.clientId as string);
  params.append("refresh_token", refreshToken);

  try {
    await axiosCustom.post("/public/auth/logout", { refreshToken });

    await axiosCustom.post(
      `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout`,
      params,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
   
    //clear token 
    keycloak.clearToken();
  } catch (error) {
    console.error("[AuthService] Logout failed", error);
  }
};
const handleAuthError = (): void => {
  keycloak.clearToken();
};

export default {
  logout,
  handleAuthError,
};
